import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import ABSegmentContext from '../../../components/ab-segment-context';

const useStarRatings = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);

  const featureEnabled = useEnabledFeature('cat-star-ratings');

  const segments = useContext(ABSegmentContext);
  const starRatingsSegmentEnabled = segments[`${abbrBrand}87`] !== 'x';

  return featureEnabled && starRatingsSegmentEnabled;
};

export default useStarRatings;
